import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";
import { CalendarProvider } from "@/services/calendarService";

interface CalendarConnectionOptionsProps {
  connectionError: string | null;
  isLoading: boolean;
  onConnectCalendar: (provider: CalendarProvider) => Promise<void>;
}

const CalendarConnectionOptions = ({
  connectionError,
  isLoading,
  onConnectCalendar,
}: CalendarConnectionOptionsProps) => {
  const handleConnectCalendar = async (provider: CalendarProvider) => {
    await onConnectCalendar(provider);
  };

  return (
    <div className="space-y-2">
      <div className="text-sm text-muted-foreground mb-2">
        Connect your calendar to add focus time automatically:
      </div>
      {connectionError && (
        <div className="p-3 mb-3 border border-red-300 bg-red-50 rounded-md flex items-start space-x-2">
          <Info className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" />
        </div>
      )}
      <div className="flex space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleConnectCalendar("google")}
          disabled={isLoading}
        >
          Connect Google Calendar
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => handleConnectCalendar("outlook")}
          disabled={isLoading}
        >
          Connect Outlook Calendar
        </Button>
      </div>
    </div>
  );
};

export default CalendarConnectionOptions;
